import { render, staticRenderFns } from "./downLoadFile.vue?vue&type=template&id=134b89e1&scoped=true&"
import script from "./downLoadFile.vue?vue&type=script&lang=js&"
export * from "./downLoadFile.vue?vue&type=script&lang=js&"
import style0 from "./downLoadFile.vue?vue&type=style&index=0&id=134b89e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134b89e1",
  null
  
)

export default component.exports